module.exports = __webpack_public_path__ + "img/close-text.224fa8e5.svg";